import {ActivatedRoute} from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Assessment } from 'app/shared/models/assessment';
import { AssessmentService } from 'app/shared/services/assessment.service';

@Component({
  selector: 'dac-assessment-details-view',
  templateUrl: './assessment-details-view.component.html',
  styleUrls: ['./assessment-details-view.component.css']
})
export class AssessmentDetailsViewComponent implements OnInit {

  @Input() assessment:Assessment;
  
  constructor() { 
    }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-details-view/assessment-details-view.component.ts